
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var restricted = document.getElementById(
      'ms-delivery-date-restricted'
    );

    if (!restricted) return;

    var form = document.getElementById('cart_form');
    if (!form) return;

    var ready = false;
    var checkout = document.getElementById('checkout');

    if (checkout) checkout.disabled = true;

    function showError() {
      var message = document.getElementById(
        'ms-delivery-date-error'
      );

      if (!message) {
        message = document.createElement('p');
        message.id = 'ms-delivery-date-error';
        message.setAttribute('role', 'alert');
        message.style.color = '#b00020';
        restricted.appendChild(message);
      }

      message.textContent =
        '配送希望日の設定を更新できませんでした。ページを再読み込みしてください。';
    }

    // 属性クリア完了前のチェックアウトを防ぐ
    form.addEventListener('submit', function (event) {
      if (event.submitter &&
          event.submitter.name === 'checkout' &&
          !ready) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError();
      }
    }, true);

    async function clearDeliveryDate() {
      try {
        var root = window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        var response = await fetch(root + 'cart.js', {
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!response.ok) {
          throw new Error('Cart fetch failed');
        }

        var cart = await response.json();

        if (cart.attributes &&
            cart.attributes['配送希望日']) {

          var updateResponse = await fetch(
            root + 'cart/update.js',
            {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                attributes: {
                  '配送希望日': ''
                }
              })
            }
          );

          if (!updateResponse.ok) {
            throw new Error('Cart update failed');
          }

          var updatedCart = await updateResponse.json();

          if (updatedCart.attributes &&
              updatedCart.attributes['配送希望日']) {
            throw new Error('Delivery date was not cleared');
          }
        }

        ready = true;

        if (checkout) checkout.disabled = false;

      } catch (error) {
        console.error('MSO delivery date:', error);
        showError();
      }
    }

    clearDeliveryDate();
  });
})();
